module.exports = __webpack_public_path__ + "img/logo_170_93.32c88f9d.png";